import api from './api';
import type { Patient, PaginatedResponse, FilterConfig, PatientOrder, EmailLog } from '../types';

export const patientService = {
  async getPatients(
    page: number = 1,
    pageSize: number = 10,
    filters?: FilterConfig
  ): Promise<PaginatedResponse<Patient>> {
    const params = new URLSearchParams({
      page: String(page),
      pageSize: String(pageSize),
    });

    if (filters?.search) {
      params.append('search', filters.search);
    }
    if (filters?.dateFrom) {
      params.append('dateFrom', filters.dateFrom);
    }
    if (filters?.dateTo) {
      params.append('dateTo', filters.dateTo);
    }

    const response = await api.get<PaginatedResponse<Patient>>(`/company/patients?${params.toString()}`);
    return response.data;
  },

  async getPatientById(id: string): Promise<Patient> {
    const response = await api.get<Patient>(`/company/patients/${id}`);
    return response.data;
  },

  async searchPatients(query: string): Promise<Patient[]> {
    const response = await api.get<Patient[]>(`/company/patients/search?q=${encodeURIComponent(query)}`);
    return response.data;
  },

  async getPatientOrders(patientId: string): Promise<PatientOrder[]> {
    const response = await api.get<PatientOrder[]>(`/company/patients/${patientId}/orders`);
    return response.data;
  },

  async getPatientEmailLogs(patientId: string): Promise<EmailLog[]> {
    const response = await api.get<EmailLog[]>(`/company/patients/${patientId}/email-logs`);
    return response.data;
  },
};
